
export const getPins = (props, component) => {
  const { orders, locationShop, driversRealTime, externalDrivers, isExternalDriver } = props;
  const { lat, lng } = locationShop;
  component.setState({ orders, drivers: isExternalDriver ? externalDrivers : driversRealTime });
  if (lng !== 'undefined' && lat !== 'undefined' && lat && lng) {
    component.setState({ center: locationShop });
  }
};
export const getMapCenter = (component) => {
  const { orders, drivers, centerDef } = component.state;

  if (!orders || orders.length === 0 || !drivers) return centerDef;

  const order = orders[0];

  // Chercher le driver correspondant à cette commande
  const driver = drivers.find(d => d.driverId === order.idDep);

  if (driver?.lat && driver?.long) {
    // Centrer sur le driver
    return { lat: driver.lat, lng: driver.long };
  }

  // centre moyen si aucun driver trouvé
  const points = drivers
    .filter(d => d.lat && d.long)
    .map(d => ({ lat: d.lat, lng: d.long }));

  if (points.length === 0) return centerDef;

  const latSum = points.reduce((sum, p) => sum + p.lat, 0);
  const lngSum = points.reduce((sum, p) => sum + p.lng, 0);

  return { lat: latSum / points.length, lng: lngSum / points.length };
};




